import React, { Component } from 'react';
import List from './list';
import FlextText from '../flexText';
import MenuIcon from './menuIcon';
import Styles from "./styles/menuStyles";

const frameBorder = window.innerWidth > 720?window.innerWidth/2:360;

class UvmMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      first: true,
    };
    this.escFunction = this.escFunction.bind(this);
  }

  showMenu(event) {
    const button = event.target;
    const panel = button.nextElementSibling;    
    const listItems = panel.childNodes;
    const open = panel.classList.contains("open");
    for (let i = 0; i < listItems.length; i++) {
      listItems[i].firstChild.tabIndex = open?"-1":"0";
    }      
    if (open) {
      panel.classList.remove('open');
      panel.classList.add('closed');
      button.classList.remove('open');
      button.classList.add('closed');
    } else {
      panel.classList.add('open');
      panel.classList.remove('closed');
      button.classList.add('open');
      button.classList.remove('closed');
    }
  }

  closeMenu() {
    // Close menu
    const drawer = document.getElementById("drawerMenu");
    if (document.getElementById("vidheaderVideo") !==null ) { 
      document.getElementById("vidheaderVideo").play();
    }
    const id = setInterval(frame, .005);
    let pos = 0;
    const button = document.getElementById("menuToggle");
    button.style.display = "block";
    const menuIcon = document.getElementById("menuIcon");
    menuIcon.classList.add("closed");
    menuIcon.classList.remove("open");

    function frame() {
      if (pos <= -frameBorder) {
        clearInterval(id);
        button.classList.add("closed");
        button.classList.remove("open"); 
      } else {
        // slide menu out
        pos -= 5; 
        drawer.style.left = pos + 'px'; 
      }
    }
    document.getElementById('groupTitle').firstChild.tabIndex = 0;
  }

  escFunction(event){
    if(event.keyCode === 27 && this.state.open) {
      this.setState(state => ({ open: !state.open }));
      this.closeMenu();
    }
  }

  componentDidMount(){
    document.addEventListener("keydown", this.escFunction, false);
  }

  componentWillUnmount(){
    document.removeEventListener("keydown", this.escFunction, false);
  }
  
  componentDidUpdate() {
    const x = document.getElementById("drawerMenu");
    x.getElementsByTagName('a')[0].style.borderWidth = 0;
    x.getElementsByTagName('a')[0].style.paddingTop = '19px';
    x.getElementsByTagName('a')[0].style.textTransform = 'uppercase';
  }

  buildMenus() {
    return this.props.menu.map((item, i) => (
      <List level={0} key={i} links={item} className={'menu' + i} styles={{padding:"0",marginTop:"0"}} showMenu={this.showMenu} />
    ));
  }

  toggleTabs(open) {
    const e = document.getElementsByClassName('menuLevel1');
    for (let j = 0; j < e.length; j++) {
      e[j].tabIndex = open?0:-1;
    }
    document.getElementById('groupTitle').firstChild.tabIndex = open?-1:0;
  }

  openMenu() {
    // pause video
    if (document.getElementById("vidheaderVideo") !== null) {
      document.getElementById("vidheaderVideo").pause();
    }
    const drawer = document.getElementById("drawerMenu"); 
    let pos = -frameBorder;
    const id = setInterval(frame, .005);
    const xleft = document.getElementById("menuToggleContainer").offsetLeft;
    
    function frame() {
      if (pos >= xleft) {
        drawer.style.left = xleft + "px";
        clearInterval(id);
        const button=document.getElementById("menuToggle");
        button.style.display="none";
        const menuIcon = document.getElementById("menuIcon");
        menuIcon.classList.add("open");
        button.classList.remove("closed");
      } else {
        // Slide menu in
        pos += 5;
        drawer.style.left = pos + 'px'; 
      } 
    }
    document.getElementById('groupTitle').firstChild.tabIndex = -1;
  }

  handleDrawerToggle = (event) => {
    // Toggle open state
    this.setState(state => ({ open: !state.open }));

    if (!this.state.open) {
      this.openMenu();
      this.toggleTabs(true);
    } else {
      this.closeMenu();
      this.toggleTabs(false);
    }
  }

  render() {
    let visible = Styles.visible;
    let modal = Styles.modal;
    if (this.state.open) {
      visible = {
        position:"absolute",
        left:"-1000px",
        zIndex: "6000",
        opacity:1,
        backgroundColor:"#efefef",
      };
      modal = {
        position: "fixed",
        top: "135px",
        right: "0",
        bottom: "0",
        left: "0",
        background: "#fff",
        zIndex: "5000",
        opacity: ".9",
        WebkitTransition: "opacity 400ms ease-in",
        MozTransition: "opacity 400ms ease-in",
        transition: "opacity 400ms ease-in",
        pointerEvents: "all"
      };
    }

    return (
      <div id="MenuBar" style={{
        border: "solid rgb(226, 226, 226)",
        borderWidth:"2px 0",
        marginTop: "24px",
        backgroundColor:"rgb(247, 247, 247)",
      }}>
        <div style={{maxWidth: "1200px", margin:"auto",height:"60px",position:"relative"}}>
          <MenuIcon handleDrawerToggle={this.handleDrawerToggle} />
          <FlextText url={this.props.menu[0][0].uri} max="20" min="17" per=".75" tag="div" id="groupTitle" styles={Styles.grouptitle}>{this.props.groupTitle}</FlextText>
          <nav tabIndex="-1" className="menu" id="drawerMenu" style={{...visible,top:"0",width: "350px", borderTop:"60px solid #007155", overflow:"auto"}}>
            {this.buildMenus()}
          </nav>
          <div onClick={this.handleDrawerToggle} id="modal" className="modalDialog" style={{...modal}}>
          </div>
        </div>
      </div>
    );
  }
}

export default UvmMenu;
